import {
  get,
  post,
  put,
} from '../axios'

class Clue {
  async getClueList(param) {
    const res = await get('/Clue/GetClueList', param)
    return res
  }
  async getCluePageList(param) {
    const res = await get('/Clue/GetCluePageList', param)
    return res
  }
  async getClueDetail(param) {
    const res = await get('/Clue/GetClueInfoByClueId', param)
    return res
  }
  async getClueBaseInfo(param) {
    const res = await get('/Clue/GetClueBaseInfoById', param)
    return res
  }
  async addClue(data,param) {
    const res = await post('/Clue/AddClue',data,param)
    return res
  }
  async updateClue(data,param) {
    const res = await put('/Clue/UpdateClue',data,param)
    return res
  }
}
export default new Clue()